import React from "react";
import { useTranslation } from "../../../i18n";
import DeletionCaseReviewsSection from "./DeletionCaseReviewsSection";
import DeletionCasePricingPanel from "./DeletionCasePricingPanel";
import DeletionCaseOutcomeSummary from "./DeletionCaseOutcomeSummary";

function formatDateTime(iso, locale) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString(locale === "de" ? "de-DE" : "en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/**
 * Expanded case details: optional pricing, justification, linked reviews.
 * Use showReviewsSection={false} for admin when review cards are shown elsewhere (e.g. outcome panel).
 */
const DeletionCaseExpandedPanel = ({
  justification,
  updatedAt,
  items,
  pricing = null,
  showPricing = false,
  showJustification = true,
  showReviewsSection = true,
  outcomeSummary = null,
  outcomeEditor = null,
  showReviewOutcomes = false,
  className = "",
}) => {
  const { t, locale } = useTranslation();

  return (
    <div className={`space-y-5 ${className}`}>
      {showPricing && pricing ? (
        <DeletionCasePricingPanel pricing={pricing} items={items} />
      ) : null}

      {outcomeEditor}

      {!outcomeEditor && outcomeSummary?.total > 0 ? (
        <div className="rounded-[12px] border border-[#e8ecf0] bg-white px-4 py-3">
          <p className="text-[12px] font-semibold uppercase tracking-wide text-[#94a3b8]">
            {t("deletionCaseUi.deletionOutcome")}
          </p>
          <div className="mt-2">
            <DeletionCaseOutcomeSummary summary={outcomeSummary} />
          </div>
        </div>
      ) : null}

      {showJustification && showReviewsSection ? (
        <>
          <div className="rounded-[12px] border border-[#e8ecf0] bg-white p-4 md:p-5">
            <p className="text-[12px] font-semibold uppercase tracking-wide text-[#94a3b8]">
              {t("deletionCaseUi.justification")}
            </p>
            <p className="mt-3 whitespace-pre-wrap text-[14px] leading-relaxed text-[#334155]">
              {justification || "—"}
            </p>
            {updatedAt ? (
              <p className="mt-4 text-[12px] text-[#64748b]">
                {t("deletionCaseUi.lastUpdated", {
                  date: formatDateTime(updatedAt, locale),
                })}
              </p>
            ) : null}
          </div>
          <DeletionCaseReviewsSection
            items={items}
            variant="panel"
            showOutcomeBadges={showReviewOutcomes || Boolean(outcomeEditor)}
          />
        </>
      ) : showJustification ? (
        <div className="rounded-[12px] border border-[#e8ecf0] bg-white p-4 md:p-5">
          <p className="text-[12px] font-semibold uppercase tracking-wide text-[#94a3b8]">
            {t("deletionCaseUi.justification")}
          </p>
          <p className="mt-3 whitespace-pre-wrap text-[14px] leading-relaxed text-[#334155]">
            {justification || "—"}
          </p>
          {updatedAt ? (
            <p className="mt-4 text-[12px] text-[#64748b]">
              {t("deletionCaseUi.lastUpdated", {
                date: formatDateTime(updatedAt, locale),
              })}
            </p>
          ) : null}
        </div>
      ) : showReviewsSection ? (
        <DeletionCaseReviewsSection
          items={items}
          variant="panel"
          showOutcomeBadges={showReviewOutcomes || Boolean(outcomeEditor)}
        />
      ) : null}
    </div>
  );
};

export default DeletionCaseExpandedPanel;
